// @flow
export const MEMBERSHIPS = {
  GROUP: 'group',
  PROGRAM: 'program',
};

export const ALL_ITEMS = 'All';
